<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">

  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_WEB_USER_RECIPIENT_MAPPING' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_WEB_USER_RECIPIENT_MAPPING' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>

  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- web-user-dropdown -->
    <esc-web-user-dropdown 
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="webUserSelected($event)"
      [previousData]="detail"
      [requiredError]="usernameRequired"
      [disabled]="isDisabled"
      >
    </esc-web-user-dropdown>

    <!-- recipient-dropdown -->
    <esc-recipient-dropdown 
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="recipientSelected($event)"
      [previousData]="detail"
      [requiredError]="fullnameRequired"
      [disabled]="isDisabled"
      *ngIf="detail?.id"
      >
    </esc-recipient-dropdown>

    <esc-recipient-multiselect-dropdown 
      class="width-100" 
      [labelFlex]="20"
      [formWrapperFlex]="'100'" 
      [hasTextLabel]="false"
      [placeHolder]="'LABEL_RECIPIENT' | translate"
      [wrapperLayoutAlign]="'start center'"
      [isRequired]="false"
      [groupMntDropdown]="false"
      [previousData]="detail"
      [disabled]="isDisabled"
      (recipientSelected)="recipientSelected($event)"
      *ngIf="!detail?.id"
      >
    </esc-recipient-multiselect-dropdown>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>

  </div>
</form>